/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LegacyReferralViewModel } from './LegacyReferralViewModel'; 

export function getLegacyReferralOptions(id: string, onSuccess?: (result: LegacyReferralViewModel) => void) {
	return queryOptions({
		queryKey: ['legacy-referral', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/referrals/queries/getlegacyreferral/' + id;
			const resp = await axios.get<LegacyReferralViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}